import { defineField, defineType } from 'sanity'
import { richTextSimple } from '../../data/richText'

export default defineType({
  name: 'stepGuide',
  title: 'Step Guide',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Steps',
      name: 'steps',
      type: 'array',
      of: [
        {
          type: 'object',
          name: 'stepGuideItem',
          fields: [
            defineField({
              title: 'Title',
              name: 'title',
              type: 'string',
            }),
            defineField({
              title: 'Content',
              name: 'content',
              type: 'array',
              of: richTextSimple,
            }),
            defineField({
              title: 'Media Type',
              name: 'mediaType',
              type: 'string',
              options: {
                direction: 'horizontal',
                list: [
                  { value: 'images', title: 'Images' },
                  { value: 'video', title: 'Video' },
                ],
              },
              initialValue: 'images',
            }),
            defineField({
              title: 'Images',
              name: 'images',
              type: 'array',
              of: [
                {
                  type: 'image',
                  options: {
                    hotspot: true,
                  },
                },
              ],
              hidden: ({ parent }) => parent?.mediaType !== 'images',
            }),
            defineField({
              title: 'Mux Video',
              name: 'muxVideo',
              type: 'mux.video',
              description: 'Add a video using Mux.',
              hidden: ({ parent }) => parent?.mediaType !== 'video',
            }),
            defineField({
              title: 'YouTube Video (Legacy)',
              name: 'youtubeVideo',
              type: 'youtubeVideo',
              description: 'Legacy field - Use Mux Video instead.',
              readOnly: true,
              hidden: ({ parent }) => parent?.mediaType !== 'video',
            }),
          ],
          preview: {
            select: {
              title: 'title',
              media: 'images.0',
              mediaType: 'mediaType',
            },
            prepare({ title, media, mediaType }) {
              return {
                title,
                subtitle: `Step Guide Item - ${
                  mediaType === 'video' ? 'Video' : 'Images'
                }`,
                media: mediaType === 'images' ? media : null,
              }
            },
          },
        },
      ],
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title }) {
      return {
        title,
        subtitle: 'Step Guide',
      }
    },
  },
})